import React from 'react';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Navigate } from 'react-router-dom';

interface Props {
  to: string;
}

export default function SchoolyearRedirect(props: Props) {
  const { to, ...rest } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  return (
    <Navigate
      to={`/annee-scolaire/${schoolyear.id}/ecole/${school.id}/${to}`}
      replace
      {...rest}
    />
  );
}
